import React, { useState } from "react";
import { resolveFlagSrc } from "../../utils/flag-assets";
import { MAP_SELECTION_GLOW, MAP_SELECTION_COLOR } from "../../utils/map-selection-glow";

interface CountryFlagMarkerProps {
  countryCode: string;
  iso2?: string;
  name?: string;
  /** Screen pixels — keep constant across zoom (do not use em). */
  size?: number;
  isSelected?: boolean;
  onClick?: () => void;
  onMouseOver?: () => void;
  onMouseOut?: () => void;
}

const CountryFlagMarker: React.FC<CountryFlagMarkerProps> = ({
  countryCode,
  iso2,
  name,
  size = 32,
  isSelected = false,
  onClick,
  onMouseOver,
  onMouseOut,
}) => {
  const [failed, setFailed] = useState(false);
  const flagSrc = resolveFlagSrc(countryCode, iso2);

  if (!flagSrc || failed) {
    return null;
  }

  const label = name || countryCode;
  const px = Math.max(12, Math.round(size));
  const border = px <= 16 ? 1 : 2;

  return (
    <img
      src={flagSrc}
      alt={`${label} flag`}
      title={label}
      width={px}
      height={px}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
      onError={() => setFailed(true)}
      style={{
        width: px,
        height: px,
        minWidth: px,
        minHeight: px,
        borderRadius: "50%",
        border: isSelected
          ? `${border + 1}px solid ${MAP_SELECTION_COLOR}`
          : `${border}px solid #ffffff70`,
        objectFit: "cover",
        cursor: onClick ? "pointer" : "default",
        pointerEvents: "auto",
        display: "block",
        flexShrink: 0,
        filter: isSelected ? MAP_SELECTION_GLOW : "none",
        boxShadow: isSelected
          ? `0 0 0 2px ${MAP_SELECTION_COLOR}55`
          : undefined,
      }}
    />
  );
};

export default React.memo(CountryFlagMarker);
